// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__13iIC","info":"UpdateTermsInfo_info__3L5tF"};